import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';

function LtConfirmStudentInfoDrawerCtrl(
  $scope,
  $timeout,
  GradeService,
  ValidationService,
  ErrorLogService,
  CommonService
) {
  this.teacherName = null;
  this.subjectGrade = null;
  this.dontKnowTeacherName = false;
  this.selectedEventInfo = $scope.selectedEventInfo;
  $scope.confirmStudentInfoSubText = 'CONF_STUD_GRADE_HEADER';
  $scope.showConfirmStudentGrade = false;
  $scope.showConfirmTeacherName = false;

  LtSelectionDrawerCtrl.call(this, $scope, $timeout);

  var unwatch = $scope.$watch(
    'selectedEventInfo',
    function (eventInfo) {
      if (!!eventInfo) {
        this.selectedEventInfo = eventInfo;
        $scope.showConfirmStudentGrade = CommonService.gradeRequired(this.selectedEventInfo);
        $scope.showConfirmTeacherName = CommonService.teacherNameRequired(this.selectedEventInfo);
        if ($scope.showConfirmTeacherName) {
          $scope.confirmStudentInfoSubText = 'CONF_STUD_GRADE_TEACHER_HEADER';
        }
        this.grades = GradeService.getGrades();
      }
    }.bind(this)
  );

  $scope.$on('$destroy', function () {
    unwatch();
  });

  this.answer = function () {
    var formData = {};
    formData.subjectTeacherName = this.teacherName;
    formData.subjectGrade = this.subjectGrade;
    formData.dontKnowTeacherName = this.dontKnowTeacherName;
    $scope.onAnswer({ formData: formData });
    this.reset();
  };

  this.onCancel = function () {
    this.reset();
    try {
      $scope.confirmStudentInfoFormId.$setPristine();
      $scope.confirmStudentInfoFormId.$setUntouched();
    } catch (error) {
      ErrorLogService(error);
    }
    $scope.onCancel();
  };

  this.isTeacherNameValid = function () {
    return !!this.teacherName && this.teacherName.length > 0;
  };

  this.disableShopNowButton = function () {
    var disableFlag = false;
    if (!!$scope.showConfirmTeacherName && !this.dontKnowTeacherName && !this.isTeacherNameValid()) {
      disableFlag = true;
    }
    if (!!$scope.showConfirmStudentGrade && !disableFlag && !this.subjectGrade) {
      disableFlag = true;
    }
    return disableFlag;
  };

  this.resetTeacher = function () {
    this.teacherName = '';
    ValidationService.resetErrors($scope.confirmStudentInfoFormId.teacherName);
  };

  this.reset = function () {
    this.teacherName = null;
    this.subjectGrade = null;
    this.dontKnowTeacherName = false;
  };
}

App.controller('LtConfirmStudentInfoDrawerCtrl', [
  '$scope',
  '$timeout',
  'GradeService',
  'ValidationService',
  'ErrorLogService',
  'CommonService',
  LtConfirmStudentInfoDrawerCtrl
]);
